<template>
  <div class="type-select px-2 py-4 mb-4">
    <div @change="handleChange" class="filter-body px-1.5 mt-4">
        <div class="select cursor-pointer relative transition group text-sm">
            <select dusk="filter-type-select" class="border border-payneMiddle group-hover:border-yank w-full cursor-pointer h-11 transition duration-300 focus:outline-none select-none relative z-10 bg-transparent" v-model="selectedType">
                <option disabled :value="null">Choose An Option</option>
                <option value="png">png</option>
                <option value="jpg">jpg</option>
                <option value="gif">gif</option>
                <option value="mp4">mp4</option>
            </select>
            <div class="icon absolute inset-y-0 right-0 w-11 flex items-center justify-center border-l border-payneMiddle group-hover:border-yank transition duration-300">
            <svg class="h-4 w-4 text-payneMiddle group-hover:text-yank transition duration-300" height="24" width="24" viewBox="0 0 24 24" version="1.1" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(1,0,0,1,0,0)"><path d="M 23.25,7.311L12.53,18.03c-0.292,0.293-0.767,0.293-1.059,0.001c0,0-0.001-0.001-0.001-0.001L0.75,7.311" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MimeTypeFilter',
    
    props: {
      value: String,
      enabledFilters: Array,
    },

    data() {
      return {
        enabled: this.enabledFilters,
        selectedType: this.value,
      }
    },

    computed: {
      isEnabled() {
        return this.enabled.includes('type')
      }
    },

    watch: {
      selectedType(type) {
        this.$emit('input', type)
      }
    },

    methods: {
      handleChange() {
        this.$emit('change', {value: this.selectedType, filter: 'mime_type'})
      }
    }
  }
</script>
<style scoped>
  select {
    -webkit-appearance: none;
    padding: .5rem 3.25rem .5rem 1rem;
    box-sizing: border-box;
    border-radius: .5rem;
  }
</style>
